import { $isCommandMenuQueryNode } from '#pplx/frontend/composer-sdk/lexical/nodes/CommandMenuQueryNodeSupport.js';
import { $getRoot, $getSelection, $isElementNode, $isRangeSelection, $isTextNode } from 'lexical';
export function $getCommandMenuQueryNodes() {
    const nodes = [];
    const visit = (node) => {
        if ($isCommandMenuQueryNode(node)) {
            nodes.push(node);
            return;
        }
        if ($isElementNode(node))
            node.getChildren().forEach(visit);
    };
    visit($getRoot());
    return nodes;
}
export function $getCommandMenuQueryNode() {
    return $getCommandMenuQueryNodes()[0] ?? null;
}
export function $removeCommandMenuQueryNodes() {
    const nodes = $getCommandMenuQueryNodes();
    nodes.forEach((node) => node.remove());
    return nodes.length > 0;
}
export function $getActiveComputerCommandQuery() {
    const node = $getCommandMenuQueryNode();
    const textNode = node?.getPreviousSibling();
    const parentNode = node?.getParent();
    if (!node || !parentNode || !$isElementNode(parentNode))
        return null;
    const markerOffset = parentNode
        .getChildren()
        .findIndex((child) => child.getKey() === node.getKey());
    if (markerOffset < 0)
        return null;
    if (!$isTextNode(textNode)) {
        if (node.__source !== 'manual' || node.__queryStartOffset !== 0)
            return null;
        return {
            markerOffset,
            node,
            parentNode,
            query: '',
            source: node.__source,
            textNode: null,
        };
    }
    const text = textNode.getTextContent();
    if (node.__queryStartOffset > text.length)
        return null;
    if (node.__source === 'slash' && text[node.__queryStartOffset - 1] !== '/')
        return null;
    return {
        markerOffset,
        node,
        parentNode,
        query: text.slice(node.__queryStartOffset),
        source: node.__source,
        textNode,
    };
}
export function $commitActiveComputerCommandQuery() {
    return $removeCommandMenuQueryNodes();
}
export function $clearActiveComputerCommandQuery() {
    const activeQuery = $getActiveComputerCommandQuery();
    if (!activeQuery)
        return false;
    const { node, parentNode, source, textNode } = activeQuery;
    const removalStartOffset = source === 'slash' ? node.__queryStartOffset - 1 : node.__queryStartOffset;
    if (removalStartOffset < 0)
        return false;
    if (textNode) {
        const text = textNode.getTextContent();
        textNode.setTextContent(text.slice(0, removalStartOffset));
        textNode.select(removalStartOffset, removalStartOffset);
    }
    else {
        parentNode.select(activeQuery.markerOffset, activeQuery.markerOffset);
    }
    node.remove();
    return true;
}
export function $replaceActiveComputerCommandQuery(nodes) {
    if (!$clearActiveComputerCommandQuery())
        return false;
    const selection = $getSelection();
    if (!$isRangeSelection(selection))
        return false;
    selection.insertNodes(nodes);
    return true;
}
//# sourceMappingURL=ComputerCommandQueryPluginSupport.js.map